export default "__VITE_PUBLIC_ASSET__a0b59a67__"